import React, { useState, useEffect } from "react";

const BANNER_KEY = "agreementBannerDismissed";
const BANNER_GO_LIVE = new Date("2026-02-25T12:00:00");
const BANNER_EXPIRY_DAYS = 30;

const AgreementUpdateBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const now = new Date();
    const expiryDate = new Date(BANNER_GO_LIVE);
    expiryDate.setDate(expiryDate.getDate() + BANNER_EXPIRY_DAYS);

    const withinWindow = now >= BANNER_GO_LIVE && now <= expiryDate;

    const dismissed = localStorage.getItem(BANNER_KEY) === "true";

    if (withinWindow && !dismissed) {
      setVisible(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(BANNER_KEY, "true");
    setVisible(false);
  };

  if (!visible) return null;

  const effectiveDate = BANNER_GO_LIVE.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div
      role="alert"
      aria-live="polite"
      className="w-full"
      style={{
        backgroundColor: "#009999",
        color: "#ffffff",
        padding: "14px 20px",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: "16px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        borderRadius: "4px",
        marginBottom: "16px",
      }}
    >
      <div style={{ flex: 1 }}>
        <p style={{ fontWeight: "700", fontSize: "15px", marginBottom: "6px" }}>
          Participant Agreement and Coalition Data Use Agreement Updates
        </p>
        <p
          style={{ fontSize: "14px", marginBottom: "10px", lineHeight: "1.5" }}
        >
          We've updated our participant and coalition data use agreements, which
          are effective {effectiveDate}.
        </p>
        <p style={{ fontWeight: "600", fontSize: "13px", marginBottom: "4px" }}>
          Learn More
        </p>
        <ul style={{ listStyle: "disc", paddingLeft: "18px", margin: 0 }}>
          <li style={{ marginBottom: "4px" }}>
            <a
              href="https://www.shelteranimalscount.org/participant-agreement"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#ffffff",
                textDecoration: "underline",
                fontSize: "13px",
              }}
            >
              Participant Agreement – Shelter Animals Count
            </a>
          </li>
          <li>
            <a
              href="https://www.shelteranimalscount.org/coalition-data-use-agreement"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#ffffff",
                textDecoration: "underline",
                fontSize: "13px",
              }}
            >
              Coalition Data Use Agreement – Shelter Animals Count
            </a>
          </li>
        </ul>
      </div>

      <button
        onClick={handleClose}
        aria-label="Close notification"
        style={{
          background: "transparent",
          border: "none",
          color: "#ffffff",
          cursor: "pointer",
          fontSize: "20px",
          lineHeight: "1",
          padding: "0",
          flexShrink: 0,
          marginTop: "2px",
        }}
      >
        &times;
      </button>
    </div>
  );
};

export default AgreementUpdateBanner;
